<template>
  <div class="">

    <div class="load" v-if="spinning == true">
      <a-spin :spinning="spinning" tip="Loading..."></a-spin>
    </div>

    <div id="components-form-demo-advanced-search">
      <a-form
              class="ant-advanced-search-form"
              :form="form"
              @submit="handleSearch"
      >
        <a-row :gutter="24">

          <a-col :span="4">
            <a-form-item label="垛二维码：">
              <a-input placeholder="请输入垛码进行查询" v-model="param.code" @pressEnter="getList(0)" />
            </a-form-item>
          </a-col>

          <a-col span="8">
            <a-form-item label="日期：">
              <a-range-picker
                      show-time
                      format="YYYY/MM/DD"
                      :value="[this.moment(createValue[0], dateFormat),this.moment(createValue[1], dateFormat)]"
                      @change="onDateChange"
              />
            </a-form-item>
          </a-col>

          <a-col :span="4">
            <a-form-item label="数据状态：">
              <a-select v-model="param.isError" placeholder="请选择" @change="dataStatusChange">
                <a-select-option value="">全部</a-select-option>
                <a-select-option :value="item.value" v-for="(item,index) in dataStatusList" :key="index">
                  {{ item.desc }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="处理状态：">
              <a-select v-model="param.isConfig" placeholder="请选择" @change="operStatusChange">
                <a-select-option value="">全部</a-select-option>
                <a-select-option :value="item.value" v-for="(item,index) in operStatusList" :key="index">
                  {{ item.desc }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


          <a-col :span="4" :style="{ textAlign: 'right' }">
            <a-button type="primary" html-type="submit">
              查询
            </a-button>
          </a-col>
        </a-row>
      </a-form>
      <!-- 表格 -->
      <div class="table">
        <a-table
                :columns="columns"
                :dataSource="dataList"
                :pagination="pagination"
                rowKey="id"
                @change="TableChange"
        >
          <template slot="serial" slot-scope="text, record, index">
            <template>
              {{ ((pagination.current - 1)*pagination.pageSize) + (index+1) }}
            </template>
          </template>
          <a slot="name" slot-scope="text">{{ text }}</a>

          <template slot="sampleDate" slot-scope="text, record, index">
            <template>
              {{text | sampleDateFilter}}
            </template>
          </template>

          <template slot="isError" slot-scope="text, record, index">

            <label v-if="record.isError > 0" slot="isError" color="green" style="cursor: pointer;">
              {{text | errorFilter}}
            </label>


            <a-tag v-if="record.isConfig == 99" slot="isConfig" color="green" style="cursor: pointer;">
              已忽略
            </a-tag>
            <a-tag v-else-if="record.isConfig == 88" slot="isConfig" color="green" style="cursor: pointer;">
              已处理
            </a-tag>
            <a-tag v-else-if="record.isConfig == 1" slot="isConfig" color="red" @click="toIngore(record)" style="cursor: pointer;">
              点击忽略
            </a-tag>
            <a-tag v-else-if="record.isError == 3 && record.isConfig != 99" slot="isConfig" color="red" @click="toIngore(record)" style="cursor: pointer;">
              点击忽略
            </a-tag>
            <a-tag v-else slot="isConfig" color="red" @click="toIngore(record)" style="cursor: pointer;">
              点击忽略
            </a-tag>

            <a-tag v-if="record.codeNum > 39 && record.isConfig < 66" slot="isConfig" color="green" @click="toAutoManage(record)" style="cursor: pointer;">
              自动处理
            </a-tag>

          </template>


          <template slot="opera" slot-scope="text,record">
            <a-tag v-if="record.codeNum == 39 && record.isError == 0" slot="opera" color="green" @click="toEdit(record)"
                   style="cursor: pointer;">
              堆码管理
            </a-tag>
            <a-tag v-if="record.codeNum != 39 || record.isError > 0" slot="opera" color="red" @click="toEdit(record)"
                   style="cursor: pointer;">
              堆码管理
            </a-tag>
          </template>
        </a-table>

      </div>
    </div>



    <!-- 删除弹框 -->
    <div>
      <a-modal
              title="提示"
              :visible="visible"
              :confirm-loading="confirmLoading"
              @ok="handleOk"
              @cancel="handleCancel"
              ok-text="确认" cancel-text="取消"
      >
        <p>{{ ModalText }}</p>
      </a-modal>
    </div>
  </div>
</template>
<script>

import {wallErrorList,wallConfig,wallAutoManage} from '@/api/wall/wall'
import {demoList} from '@/api/demo/demo'
import {formatTime,getMonthStr} from '@/utils/time'
import moment from 'moment'

const columns = [
  {
    title: "序号 ",
    dataIndex: "serial",
    key: "serial",
    align: "center",
    scopedSlots: {customRender: 'serial'}
  },
  {
    title: "采集点 ",
    dataIndex: "demoName",
    key: "demoName",
    align: "center"
  },
  {
    title: "垛编号 ",
    dataIndex: "no",
    key: "no",
    align: "center"
  },
  {
    title: "包数 ",
    dataIndex: "codeNum",
    key: "codeNum",
    align: "center"
  },
  {
    title: "采集时间",
    key: "sampleDate",
    dataIndex: "sampleDate",
    align: "center",
    scopedSlots: {customRender: 'sampleDate'}
  },
  {
    title: "数据状态 ",
    key: "isError",
    dataIndex: "isError",
    scopedSlots: {customRender: "isError"}
  },
  {
    title: "操作 ",
    key: "opera",
    dataIndex: "opera",
    scopedSlots: {customRender: "opera"}
  }
];

const dataList = [];

export default {
  data() {
    return {
      dateFormat: "YYYY/MM/DD HH:mm:ss",
      moment,
      pagination: {
        current: 1,
        pageNo: 1,
        pageSize: 100, // 默认每页显示数量
        showSizeChanger: true, // 显示可改变每页数量
        pageSizeOptions: ['100', '50', '30'], // 每页数量选项
        showTotal: total => `共有 ${total} 条`, // 显示总数
        // //onChange: (page, pageSize) => this.changePage(page, pageSize), // 点击页码事件
        total: 0 // 总条数
      },

      form: this.$form.createForm(this, {
        name: "",
      }),
      param: {
        size: 100,
        page: 1,
        code: "",
        startDate: "",
        endDate: "",
        isError: "",
        isConfig: ""
      },
      dataList,
      columns,

      currentItem:{},

      ModalText: '确定要删除该信息吗？',
      visible: false,
      confirmLoading: false,

      userName: "",

      areaIds: [0, 0, 0],
      optionAreas: [
        {
          value: '0',
          label: '全国'
        }
      ],
      showSearch: {
        filter: (inputValue, path) => {
          return path.some(option => {
                    // label搜索
                    return fullText(inputValue, option.label);
                  }
          )
        },
        matchInputWidth: true
      },

      demoList: [],
      compList: [],
      spinning: false,

      id: 0,

      trueList: [
        {value: 0, desc: '否'},
        {value: 1, desc: '是'}
      ],

      statusList: [
        {value: 0, desc: '正常'},
        {value: 1, desc: '异常'},
      ],
      dataStatusList: [
        {value: 1, desc: '数量错误'},
        {value: 2, desc: '条码错误'},
        {value: 3, desc: '手动录入'},
      ],
      operStatusList: [
        {value: 88, desc: '已处理'},
        {value: 99, desc: '已忽略'},
        {value: 1, desc: '待处理'},
      ],

      userObj: {},
      createValue: [],
    };
  },
  computed: {},
  filters: {
    trueFilter(status) {
      if (status === 0)
        return "否"
      else if (status === 1)
        return "是"
      else
        return "否"
    },
    errorFilter(status) {
      console.log("errorFilter "+status)
      if (status === 1)
        return "数量错误"
      else if (status === 2)
        return "条码错误"
      else if (status === 3)
        return "手动录入"
      else if (status === 99)
        return "牌号错误"
      else
        return "正常"
    },

    sampleDateFilter(status) {
      if (status == '2000-01-01 00:00:00')
        return "未采样"
      else
        return status
    }
  },
  created() {
    //日期初始化
    var startDate = Date.now();
    var endDate = Date.now();
    this.param.startDate = getMonthStr(startDate, -1)
    this.param.endDate = formatTime(endDate, '{y}-{m}-{d}')

    this.createValue = [this.param.startDate, this.param.endDate]

    this.userObj = JSON.parse(localStorage.getItem("userObj"))

    var areaId = this.userObj.areaId

    // 获取当前账号信息
    this.param.areaId = areaId
    this.getDemo();

    this.getList(0);
  },
  updated() {
    console.log("updated");
  },
  methods: {

    demoChange(value) {
      this.param.demoId = value
      this.getList(0)
    },

    dataStatusChange(value) {
      this.param.isError = value
      this.getList(0)
    },
    operStatusChange(value) {
      this.param.isConfig = value
      this.getList(0)
    },

    getDemo() {
      demoList({
        page: 1,
        size: 100
      }).then(res => {
        this.demoList = res.data.list

      });
    },


    getList(number) {
      if (number === 0) {
        this.pagination.current = 1
        this.param.page = 1
      }

      var param = this.param

      wallErrorList(param).then(response => {
        this.dataList = response.data.list
        if (this.dataList) {
          this.pagination.total = response.data.total
        }
      })
    },

    // 搜索
    handleSearch(e) {
      e.preventDefault();
      this.form.validateFields((error, values) => {
        console.log("error", error);
        console.log("Received values of form: ", values);
      });
      this.getList(0);
    },


    //打开删除弹框
    deleteData(value) {
      this.id = value.id;
      this.visible = true;
    },
    //确定删除
    handleOk() {
      this.visible = false;
    },
    //取消删除
    handleCancel() {
      this.visible = false;
    },
    toIngore(value) {

      var self = this
      this.$confirm({
        title: '忽略',
        content: `是否确认忽略当前错误信息？`,
        cancelText: '取消',
        okText: '确定',
        okType: 'danger',
        onOk () {

            wallConfig({
              id:value.id,
              status:99
            }).then(response => {
              self.getList()
            })


        }
      })


    },
    toAutoManage(value) {

      var self = this
      this.$confirm({
        title: '自动拆分',
        content: `是否自动拆分错误堆垛数据？`,
        cancelText: '取消',
        okText: '确定',
        okType: 'danger',
        onOk () {

          wallAutoManage({
            id:value.id
          }).then(response => {
            self.getList()
          })


        }
      })


    },

    toEdit(value) {
      this.id = value.id;
      this.$router.push({
        path: "/index/edit/erroredit",
        query: {
          id: this.id,
          show: 1
        }
      });
    },

    onDateChange(date, dateString) {
      this.createValue = date
      this.param.startDate = dateString[0]
      this.param.endDate = dateString[1]
      this.getList(0);
    },

    TableChange(e) {
      // 每页数量变更
      this.pagination.current = e.current
      this.param.page = e.current
      this.param.size = e.pageSize
      this.getList()
    },
    changePage(page, pageSize) {
      // 页码变更
      this.pagination.current = page
      this.param.page = page
      this.param.size = pageSize
      this.getList()
    },

  }
};
</script>
<style scoped>
  .ant-advanced-search-form {
    padding: 24px;
    background: #ffffff;
    /* border: 1px solid #d9d9d9; */
    /* border-radius: 6px; */
  }

  .ant-advanced-search-form .ant-form-item {
    display: flex;
  }

  .ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
  }

  #components-form-demo-advanced-search .ant-form {
    max-width: none;
  }

  #components-form-demo-advanced-search .search-result-list {
    margin-top: 16px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    background-color: #ffffff;
    min-height: 200px;
    text-align: center;
    padding-top: 80px;
  }

  .table {
    margin-top: 20px;
    background: #ffffff;
    padding: 20px;

  }

  /deep/ .ant-table-tbody > tr > td {
    padding: 5px 5px !important;
  }

  .load {
    width: 100%;
    height: 100%;
    background-color: #000;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    opacity: 0.3;
    /*兼容IE8及以下版本浏览器*/
    filter: alpha(opacity=30);

    display: flex;
    align-items: center;
    justify-content: center;

  }
</style>
